<template>
    <div >

            <div class="m-1 mb-3 p-1 text-center">
                <h5><img width="64px" height="64px" src="../../assets/navlogo.png" class="my-3" style="vertical-align: middle" > VO2 Master Cloud</h5>
            </div>
            <div v-if="isLoading" class="text-center">
                <b-spinner small type="grow"></b-spinner>
                Loading...
            </div>
            <b-alert v-else-if="isLoadingError" variant="warning" class="m-5" show>
                <p><span>There was a problem connecting to the platform.</span></p>
                <ul>
                    <li><span>Check your network connection.</span></li>
                    <li><span>Please refresh your browser and try again.</span></li>
                </ul>
            </b-alert>
            <div v-else class="container-fluid px-4">

                <div class="row">
                    <div class="col-12 text-center">
                        <h3> {{ agreementTitle }}</h3>
                    </div>
                </div>

                <div class="row">

                    <div class="col-12">
                        <div class="embed-border">
                        <div class="embed-responsive embed-responsive-21by9" >
                            <iframe class="embed-responsive-item" frameborder="2" :srcdoc="agreementContent"></iframe>
                        </div>
                        </div>
                    </div>

                </div>
            </div>

    </div>
</template>

<script>

    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: "AgreementPage",
        components: {
        },

        data() {
            return {
                agreementType: this.$route.params.agreementType,
                agreementTitle: '',

            }
        },
        created () {
            this.refreshAgreement();
        },
        computed: {
            ...mapGetters({
                agreement: 'agreement/current',
                isModelLoading: 'agreement/currentLoading',
                isModelLoadingError: 'agreement/currentLoadingError',
                modelLoadingErrorValue: 'agreement/currentLoadingErrorValue',
            }),
            isLoading: function() {
                return this.isModelLoading;
            },
            isLoadingError: function() {
                return this.isModelLoadingError;
            },
            loadingErrorValue: function() {
                return this.modelLoadingErrorValue;
            },

            agreementContent: function() {
                if(this.agreement) {
                    return this.agreement.content;
                }
                return '';
            }
        },
        methods: {
            ...mapActions({
                selectAgreement: 'agreement/select',
            }),
            refreshAgreement() {

                if(this.agreementType.toLowerCase() == 'termsofuse') {
                  this.agreementTitle = 'Terms Of Use Agreement';
                } else if(this.agreementType.toLowerCase() == 'privacy') {
                  this.agreementTitle = 'Privacy Policy Agreement';
                } else {
                    //TODO - error
                    return;
                }

                this.selectAgreement(this.agreementType);
            },
        }

    }
</script>

<style scoped>

    .embed-border {
        border: 5px solid gray;
        box-sizing: border-box; /* prevents extra width from being added */
    }

</style>